'use client'

import { Button } from '@/components/ui/button'

export default function Error({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className='flex h-[calc(100vh-200px)] w-screen items-center justify-center overflow-hidden'>
      <div>
        <h1 className='mb-6 text-2xl font-medium'>
          Đã có lỗi xảy ra. Vui lòng thử lại!
        </h1>

        <Button
          onClick={() => {
            window.location.replace(`/`)
          }}
          variant='white'
        >
          Trang chủ
        </Button>

        <Button
          onClick={() => {
            reset()
          }}
          variant='outline-neutral'
        >
          Thử lại
        </Button>
      </div>
    </div>
  )
}
